

class CartSamples {
  constructor(args) {
    this.selectors = {
      template: '#hc-cart-samples-template',
      openModal: '#hc-samples-modal--open',
      closeModal: '#hc-samples-modal--close',
      modal: '.cart-samples__modal',
      modalWindow: '.cart-samples__modal__container',
      currentSamplesAdded: '#hc-samples-added',
      availableSamplesCounter: '#hc-available-samples',
      maxSamplesCounter: '#hc-max-samples',
      items: '.cart-samples__item',
      itemButton: '#hc-add-sample-to-cart',
      addSamplesTrigger: '#hc-add-samples',
      samplesCartElement: '.cart-samples__header',
      samplesSelectorGrid: '.cart-samples__modal__grid',
      samplesCollectionJSON: '[data-samples-collection-json]',
      cartRemove: '.cart__remove'
    }
    
    this.goals = {
      firstTier: 4900,
      secondTier: 30000
    }
    
    this.hooks = args.hooks;
    
    this.variables = {
      availableSamples : 0,
      currentSamplesInCart: 0,
      maxSamples: 0
    }
    
    this.formData = {  
      'items': []
    };
    
    this.baseURL = window.location.origin;
    
    this.samplesCollectionProducts = args.samplesCollection;
    
    this.productSampleTemplate = `<div class="cart-samples__item">
                                    <div class="cart-samples__item__photo">
                                      <img class="cart-samples__item__image" src="" data-sizes="auto" alt="">
                                    </div>

                                    <div class="cart-samples__item__info">
                                      <a href="">
                                        <div class="cart-samples__item__info__title"></div>
                                      </a>

                                      <div id="hc-add-sample-to-cart" class="cart-samples__item__add" data-product-id="">
                                        <span>
                                          Add Sample To Cart
                                        </span>
                                      </div>

                                    </div>
                                  </div>`
  }
  
  async implement() {
    const tempThis = this;
    const cart = await fetch('/cart.js').then(res => res.json());
    
console.log("IMPLEMENT",     document.querySelector(this.selectors.openModal))
    
    document.querySelector(this.selectors.openModal).addEventListener('click', function(e) {
      e.preventDefault();
      tempThis.openModal();
    });

    /*
    document.querySelector(this.selectors.modal).addEventListener("click", (evt) => {
      const flyoutEl = document.querySelector(this.selectors.modalWindow);
      let targetEl = evt.target; // clicked element      
      do {
        if(targetEl == flyoutEl) {
          // This is a click inside, does nothing, just return.
          return;
        }
        // Go up the DOM
        targetEl = targetEl.parentNode;
      } while (targetEl);
      // This is a click outside.      
      document.querySelector(this.selectors.modal).classList.remove('open');
    });
    */

    document.querySelector(this.selectors.closeModal).addEventListener("click", function() {
      tempThis.closeModal();
    })

    document.querySelector(this.selectors.addSamplesTrigger).addEventListener('click', function() {
      tempThis.addSamples(); 
    })

    document.addEventListener(this.hooks.update, function(e) {
      console.log(e.detail)
      tempThis.update(e.detail.cart, e.detail.template)
    });
    
    document.addEventListener(this.hooks.productRemoved, function(e) {
      tempThis.productRemoved(e)
    });

    if(window.location.href.includes('/cart')) {
      document.querySelectorAll(this.selectors.cartRemove).forEach(item => {
        item.addEventListener('click', function(e) {
          tempThis.productRemoved(e)
        })
      })
    }
    
    this.resetSampleSelectorTemplate(cart);
    
    this.exists = true;
  }
  
  setVariables(cart) {
    if(cart.total_price >= this.goals.firstTier && cart.total_price < this.goals.secondTier) {
      this.variables.availableSamples = 3;
    } else if(cart.total_price >= this.goals.secondTier) {
      this.variables.availableSamples = 6;
    } 
    
    let samples = cart.items.filter(item => item.properties && item.properties['Product Type']);
    samples = samples ? samples.length : 0;
    
    this.variables.currentSamplesInCart = samples;
    this.variables.maxSamples = this.variables.availableSamples - this.variables.currentSamplesInCart;
  }
  
  updateVariables() {
    document.querySelector(this.selectors.currentSamplesAdded).innerText = this.variables.currentSamplesInCart;
    document.querySelector(this.selectors.maxSamplesCounter).innerText = this.variables.maxSamples;
    if(document.querySelector(this.selectors.availableSamplesCounter)) {
      document.querySelector(this.selectors.availableSamplesCounter).innerText = this.variables.availableSamples;
    }
  }
  
  resetSampleSelectorTemplate(cart) {
    
    const grid = document.querySelector(this.selectors.samplesSelectorGrid);
    
    grid.innerHTML = '';
    
    const samplesInCart = cart.items.filter(item => item.properties && item.properties['Product Type']).map(sample => sample.product_id);
    
    const filteredSamples = this.samplesCollectionProducts.filter(sample => !samplesInCart.includes(sample.id));

    const productSampleElements = this.constructProductSampleElements(filteredSamples);
    
    productSampleElements.forEach(element => {
      grid.appendChild(element);
    });
    
    this.setVariables(cart);
    this.updateVariables();

    this.activateSamples();
  }
  
  constructProductSampleElements(samples) {
    const elements = [];
    samples.forEach(sample => {
      const base = document.createRange().createContextualFragment(this.productSampleTemplate);
      base.querySelector('.cart-samples__item__image').src = sample.featured_image;
      base.querySelector('.cart-samples__item__info__title').innerText = sample.title;
      base.querySelector('#hc-add-sample-to-cart').setAttribute('data-product-id', sample.variants[0].id);
      base.querySelector('.cart-samples__item__info a').href = `${this.baseURL}/products/${sample.handle}`;
      elements.push(base);
    })
    
    return elements;
  }
  
  async addSamplesToCart(options) {
    let response = await fetch("/cart/add.js", options);
    let data = await response.json();
    return data;
  }
  
  async removeSampleFromCart(options) {
    let response = await fetch("/cart/change.js", options);
    let data = await response.json();
    return data;
  }

  async update(cart, template) {
    
    const samples = cart.items.filter(item => item.properties && item.properties['Product Type']);
    
    if(template.querySelector(this.selectors.samplesCartElement)) {
      if(cart.total_price > this.goals.firstTier) {
        template.querySelector(this.selectors.samplesCartElement).style.display = 'flex';
        template.querySelector(this.selectors.samplesCartElement).classList.remove('hc-hide');
      } else {
        template.querySelector(this.selectors.samplesCartElement).style.display = 'none';
        template.querySelector(this.selectors.samplesCartElement).classList.add('hc-hide');
      }
    } 
    
    this.resetSampleSelectorTemplate(cart);

    if(template.querySelector(this.selectors.openModal)) {
      if(cart.total_price > this.goals.firstTier && cart.total_price < this.goals.secondTier && samples.length === 3) {
        template.querySelector(this.selectors.openModal).classList.add('disabled');
      } else if(cart.total_price > this.goals.secondTier && samples.length === 6) {
        template.querySelector(this.selectors.openModal).classList.add('disabled');
      } else {
        template.querySelector(this.selectors.openModal).classList.remove('disabled');
      }
    }
  }
  
  async productRemoved(e) {
    let cart = await fetch('/cart.js').then(res => res.json());

    const samples = cart.items.filter(item => item.properties && item.properties['Product Type']);

    if(cart.items.length > 0 && cart.items.length === samples.length) {
      const options = {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        }
      };

      fetch('/cart/clear.js', options).then(res => res.json()).then(cart => {
        console.log(cart)
        this.updateCart(cart)   
      });
    } else if(cart.total_price < this.goals.secondTier && samples.length > 3) {
      for (let index = 0; index < 3; index++) {
        let sample = samples[index];
        const options = {
          method: "post",
          headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json'
          },
          body: JSON.stringify({
            'id': `${sample.variant_id}`,
            'quantity': 0
          })
        };

        await this.removeSampleFromCart(options);
      }
    }
    
  
    if(window.location.href.includes('/cart')) {
      window.location.reload();
    } else {
      fetch('/cart.js').then(res => res.json()).then(cart => {
        this.updateCart(cart)
      });           
    }
  }
  
  async openModal() {
    if (!this.exists) {
      await this.implement();
    }
    
    document.querySelector(this.selectors.modal).classList.add('open');
    document.querySelector(this.selectors.currentSamplesAdded).innerText = 0;
  }
  
  closeModal() {
    document.querySelector(this.selectors.modal).classList.remove('open');
  }
  
  closeWhenOutside() {
    document.querySelector(this.selectors.modal).addEventListener("click", (evt) => {
      const flyoutEl = document.querySelector(this.selectors.modalWindow);
      let targetEl = evt.target; // clicked element      
      do {
        if(targetEl == flyoutEl) {
          // This is a click inside, does nothing, just return.
          return;
        }
        // Go up the DOM
        targetEl = targetEl.parentNode;
      } while (targetEl);
      // This is a click outside.      
      this.classList.remove('open');
    })
  }
 
  
  activateSamples() {
    const tempThis = this;
    tempThis.formData.items = [];
    const items = [...document.querySelectorAll(this.selectors.items)];
    items.forEach(item => {
      item.querySelector(this.selectors.itemButton).addEventListener('click', function() {
        let currentId = parseInt(this.dataset.productId);
        
        if(!tempThis.formData.items.find(item => item.id === currentId) && tempThis.formData.items.length < tempThis.variables.maxSamples) {
          tempThis.formData.items.push({
            id: currentId,
            quantity: 1,
            properties: {
              'Product Type': 'Sample'
            }
          })
          this.classList.add('selected');
          this.innerText = 'Sample Added!'
        } else {
          tempThis.formData.items = tempThis.formData.items.filter(item => item.id !== currentId);
          this.classList.remove('selected');
          this.innerText = 'Add Sample To Cart'
        }
        
        document.querySelector(tempThis.selectors.currentSamplesAdded).innerText = tempThis.formData.items.length;
      });
    })
  }
  
  addSamples() {
    this.addSamplesToCart({
      method: "post",
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(this.formData),
    }).then(res => {
      
      if(window.location.href.includes('/cart')) {
        window.location.reload();
      } else {
        fetch('/cart.js').then(res => res.json()).then(cart => {
          this.updateCart(cart);
        })
      } 
      
      document.querySelector(this.selectors.modal).classList.remove('open');
      fetch('/cart.js').then(res => res.json()).then(cart => {
        this.setVariables(cart);
        this.updateVariables();
      })
    })
  }
  
  updateCart(cart) {
    refreshCart(cart)
  }
}